var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "elementsPickerWrap", staticClass: "form-group" },
    [
      _c("label", { staticClass: "font-size-12" }, [_vm._v(_vm._s(_vm.label))]),
      _c(
        "b-button",
        {
          ref: "elementsPickerButton",
          staticClass: "d-block inline-button",
          attrs: { variant: "outline-primary" },
          on: { click: _vm.toggleBox },
        },
        [
          _c("label", { staticClass: "mr-2" }, [
            _vm._v(
              _vm._s(
                _vm.value.length
                  ? `${_vm.value.length} Element(s) Selected`
                  : "No Elements Selected"
              )
            ),
          ]),
          _c("i", { class: _vm.angleDownIcon }),
        ]
      ),
      _vm.boxShown
        ? _c(
            "div",
            { ref: "elementsPicker", staticClass: "position-relative" },
            [
              _c(
                "ul",
                { staticClass: "elements-picker-wrap" },
                _vm._l(_vm.items, function (item, index) {
                  return _c(
                    "li",
                    {
                      key: `item-${index}`,
                      staticClass: "elements-picker-item",
                      attrs: { "data-item": item.id },
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "custom-ellipsis elements-picker-item",
                          attrs: {
                            for: `elementsPicker-${index}`,
                            "data-item": item.id,
                          },
                        },
                        [_vm._v(_vm._s(item.label))]
                      ),
                      _c("input", {
                        staticClass: "elements-picker-item",
                        attrs: {
                          type: "checkbox",
                          id: `elementsPicker-${index}`,
                          name: "elementsPicker[]",
                          "data-item": item.id,
                        },
                        domProps: {
                          value: item.id,
                          checked: !!_vm.value.includes(item.id),
                        },
                        on: { change: _vm.changeCheckbox },
                      }),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }